module.exports = __webpack_public_path__ + "static/img/pin_ambulancia_rd.409e4d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pin_ambulancia_rd.png
// module id = c6gk
// module chunks = 4